export const ACTIVE_PRODUCTS = ["ai_chat", "reviews", "webmd", "text_to_pay"];
